// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { PFixTradingWebhookResponseMessage } from '../Messages/PFixTradingWebhookResponseMessage';
import { TradingWebhookResponseMessage } from '@shared/utils/DirectMessages/Webhooks/TradingWebhookResponseMessage';
export class TradingWebhookResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const pfixMessage = new PFixTradingWebhookResponseMessage(fieldSet);
        const message = new TradingWebhookResponseMessage();
        message.id = pfixMessage.id;
        message.apiKey = pfixMessage.apiKey;
        message.secretKey = pfixMessage.secretKey;
        message.createdAt = pfixMessage.createdAt;
        message.expireAt = pfixMessage.expireAt;
        message.name = pfixMessage.name;
        message.status = pfixMessage.status;
        return [message];
    }
}
